import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  dashboardDelegation: {
    head: [],
    body: []
  },
  isLoadingDashboardDelegation: true,
  count: 0,
  userCount: 0
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_GET_DASHBOARD_DELEGATION:
      var count = ""
      var data = action.data.map(i => {
        count = i.totalCount;
        return [i.area, i.areaToDelegate, i.username, i.userCount, i.created, { ...i, isDelete: true }]
      })

      return {
        ...state,
        dashboardDelegation: {
          head: [
            {
              label: 'Area',
              align: 'left'
            },
            {
              label: 'Area to Delegate',
              align: 'left',
            },
            {
              label: 'User Name',
              align: 'left',
            },
            {
              label: 'User Count',
              align: 'right',
            },
            {
              label: 'Created Date',
              align: 'left',
            },
            {
              label: 'Action',
              align: 'right',
            },
          ],
          body: data,
        },
        count: count,
        isLoadingDashboardDelegation: false,
      }
    case types.FAILED_GET_DASHBOARD_DELEGATION:
      return {
        ...state,
        dashboardDelegation: {
          head: [],
          body: []
        },
        isLoadingDashboardDelegation: false,
        count: 0
      }
    case types.FETCH_GET_DASHBOARD_DELEGATION:
      return {
        ...state,
        dashboardDelegation: {
          head: [],
          body: []
        },
        isLoadingDashboardDelegation: true,
        count: 0
      }
    case types.SUCCESS_USER_COUNT:
      return {
        ...state,
        userCount: action.data
      }
    case types.FAILED_USER_COUNT:
      return {
        ...state,
        userCount: 0
      }
    case types.CHANGE_USER_COUNT:
      
      return {
        ...state,
        userCount: action.value
      }
    default:
      return state
  }
}
export default reducer